import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon, InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import type React from 'react';
import { cn } from '../../../shared/cn';
import { useAlertVariant } from './Alert';
const VARIANT_ICONS = {
  warning: ExclamationTriangleIcon,
  success: CheckCircleIcon,
  error: ExclamationCircleIcon,
  info: InformationCircleIcon
} as const;
export const AlertTitle = t0 => {
  const $ = _c(7);
  const {
    icon,
    handleIsOpen,
    className,
    ...props
  } = t0;
  const variant = useAlertVariant();
  const Icon = variant === "default" ? null : VARIANT_ICONS[variant];
  const t1 = Headless;
  let t2;
  if ($[0] !== className) {
    t2 = cn("text-balance text-left font-semibold text-lg leading-6 sm:text-wrap", "[[data-variant=default]_&]:text-contentPrimary", "[[data-variant=warning]_&]:text-contentYellow", "[[data-variant=success]_&]:text-contentGreen", "[[data-variant=error]_&]:text-contentRed", "[[data-variant=info]_&]:text-contentBlue", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = typeof props.children === "function" ? props.children({
    open: false
  }) : <div className="flex flex-row justify-between"><div className="flex flex-row items-center gap-3">{!icon && Icon && <Icon className="h-6 w-6 shrink-0" />}{icon && icon}{props.children}</div><Headless.Button onClick={() => handleIsOpen()}><XMarkIcon className="h-4 w-4 text-contentPrimary" /></Headless.Button></div>;
  let t4;
  if ($[2] !== props || $[3] !== t1.DialogTitle || $[4] !== t2 || $[5] !== t3) {
    t4 = <t1.DialogTitle {...props} className={t2}>{t3}</t1.DialogTitle>;
    $[2] = props;
    $[3] = t1.DialogTitle;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};